import { DataClassification, Environment, SelectorCluster, SelectorView, UserGroup } from './types';

export const filterClusters = (
  clusterListInput: SelectorCluster[],
  env: string,
  dataClassification: string,
  selectionMethod: string,
  includeProd: boolean,
  usersAdGroups: UserGroup[],
): SelectorCluster[] => {
  return clusterListInput.filter(item => {
    if (!includeProd && item.production) {
      return false;
    }

    if (item.allowedAadGroups !== undefined && item.allowedAadGroups.length > 0) {
      const userPermitted = item.allowedAadGroups.some(group => {
        return usersAdGroups.some(userGroup => userGroup.groupName === group);
      });

      if (!userPermitted) {
        return false;
      }
    }

    if (selectionMethod === SelectorView.guided && dataClassification === DataClassification.pci && !item.pci) {
      return false;
    }

    if (selectionMethod === SelectorView.guided && dataClassification === DataClassification.nonpci && item.pci) {
      return false;
    }

    if (selectionMethod === SelectorView.guided && env === Environment.nonprod && item.production) {
      return false;
    }

    if (selectionMethod === SelectorView.guided && env === Environment.prod && !item.production) {
      return false;
    }

    return true;
  });
};

export const hasPciCluster = (clusterListInput: SelectorCluster[]): boolean => {
  return clusterListInput.some(item => item.pci);
};
